// $( document ).ready(function() {
//     $('.accordion-title').click(function () {
//         var accordionItem = $(this).parent();
//         $('.accordion-item').not(accordionItem).removeClass('active').find('.accordion-content').slideUp();
//         accordionItem.toggleClass('active').find('.accordion-content').slideToggle();
//     });
//   });

 $( document ).ready(function() {
    $('.checkbox-contact').click(function () {
      $(this).toggleClass('active');
 });

$('.footer-menu-accordion').click(function () {
    $(this).find('.social-links').css({"display": "flex", "height": "0px"});;
});

 });


